import { Archive, Download, SlidersHorizontal, UserRoundMinus, UserRoundPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useViewOnly } from '@/components/templates/app-shell'
import type { BulkGroupAction } from '@/pages/ContactsBulkGroupDialog'
import type { BulkChapterAction } from '@/pages/ContactsBulkChapterDialog'

export function BulkLifecycleToolbar({
  selectedCount,
  hasSelection,
  isPending,
  exportHref,
  onSelectMatching,
  onSetField,
  onGroupChange,
  onChapterChange,
  onArchive,
}: {
  selectedCount: number
  hasSelection: boolean
  isPending: boolean
  exportHref: string
  onSelectMatching: () => void
  onSetField: () => void
  onGroupChange: (action: BulkGroupAction) => void
  onChapterChange: (action: BulkChapterAction) => void
  onArchive: () => void
}) {
  const viewOnly = useViewOnly()
  if (viewOnly || !hasSelection) return null

  return (
    <div className="flex items-center gap-3 border-b border-border bg-accent/60 px-4 py-2.5 text-body-sm">
      <span className="text-foreground">{selectedCount} selected</span>
      <Button type="button" variant="outline" size="sm" onClick={onSelectMatching}>
        Select all matching Contacts
      </Button>
      <div className="ml-auto flex flex-wrap items-center gap-2">
        <Button type="button" variant="outline" size="sm" onClick={onSetField}>
          <SlidersHorizontal className="mr-2 h-4 w-4" aria-hidden="true" />
          Set field...
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={() => onGroupChange('add')}>
          <UserRoundPlus className="mr-2 h-4 w-4" aria-hidden="true" />
          Add to Group...
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={() => onGroupChange('remove')}>
          <UserRoundMinus className="mr-2 h-4 w-4" aria-hidden="true" />
          Remove from Group...
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={() => onChapterChange('add')}>
          Add to Chapter...
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={() => onChapterChange('remove')}>
          Remove from Chapter...
        </Button>
        <Button
          type="button"
          variant="quietDestructive"
          size="sm"
          disabled={isPending}
          onClick={onArchive}
        >
          <Archive className="mr-2 h-4 w-4" aria-hidden="true" />
          Archive
        </Button>
        <Button asChild variant="outline" size="sm">
          <a href={exportHref} download="contacts.csv">
            <Download className="mr-2 h-4 w-4" aria-hidden="true" />
            Export CSV
          </a>
        </Button>
      </div>
    </div>
  )
}
